import React, { useState, useEffect, useRef, useCallback } from "react";
import Stack from "@mui/material/Stack";
import Pagination from "@mui/material/Pagination";
import { Button, Popover, OverlayTrigger, Tooltip } from "react-bootstrap";
import * as constantMessages from "../../constants/constatntMessages";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate, Link, useLocation } from "react-router-dom";
import { logOut } from "../../redux/actions/authActions/authAction";
import {
  cancelActionInList,
  fetchActionList,
  processReassign,
  processRequestForReassign,
  fetchActionListNew,
  setAttendeeAndMeetingChartFalse,
  totalPriorityCardClick,
  setCardClickType,
  setChartClickType,
} from "../../redux/actions/actionAction/ActionAction";
import {
  handlePendingCardClick,
  rechartsAllData,
  rechartsAttendeeData,
} from "../../redux/actions/actionAction/ActionAction";
import {
  handlePriorityCardClick,
  hidemytaskButton,
} from "../../redux/actions/actionAction/ActionAction";
import Alert from "../Common/Alert";
import NoDataFound from "../Common/NoDataFound";
import Loader from "../Common/Loader";
import {
  customName,
  sliceTextFromHTML,
  getColorFromId,
} from "../../helpers/commonHelpers";
import ActionDropDown from "./ActionDropDown";
import ActionFilterComponent from "./ActionFilterComponent";
import RequestForReassignModal from "./RequestForReassignModal";
import ReassignModal from "./ReassignModal";
import {
  getMeetingActionPriotityDetails,
  viewMeetingStatistics,
} from "../../redux/actions/meetingActions/MeetingAction";
import CommonModal from "../Common/CommonModal";
import ActionPieChart from "./ActionPieChart";
import TableSortLabel from "@mui/material/TableSortLabel";
// import AssignedAttendeesModal from "../Meeting/AssignedAtttendeeModal";
import AssignedAttendeesModal from "../Meeting/AssignedAttendeesModal";

const regularExpressionForAgendaTitle =
  /^[0-9a-zA-Z .,:\n;%@&#!$^*+=`~()/_'"\\\-?|{}\[\]]+$/;
const regularExpressionForSearch =
  /^[0-9a-zA-Z .,:\n;%@&#!$^*+=`~()/_'"\\\-?|{}()\[\]]+$/;
const ActionList = React.memo(() => {
  const userData = JSON.parse(localStorage.getItem("userData"));
  const accessToken = localStorage.getItem("accessToken");
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const authData = useSelector((state) => state.auth);
  const meetingData = useSelector((state) => state.meeting);
  const [errors, setErrors] = useState({});
  const actionData = useSelector((state) => state.action);
  console.log("actionData", actionData.isFilterclick);
  const isChartClicked = useSelector((state) => actionData.chartpage);
  const hideMyTaskButton = useSelector((state) => actionData.hidemyTaskButton);
  const employeeData = useSelector((state) => state.user);
  const [isCloseModalOpen, setIsCloseModalOpen] = useState(false);
  const [filter, setfilter] = useState(false);
  const [filterPayload, setFilterPayload] = useState({});
  const [isReassignModalOpen, setIsReassignModalOpen] = useState(false);
  const [page, setPage] = useState(1);
  const [showUserData, setShowUserData] = useState(false);
  const [isMyTasks, setIsMyTasks] = useState(false);
  const [loading, setLoading] = useState(false);
  const [orderBy, setOrderBy] = useState([
    "mainDueDate",
    "priority",
    "title",
    "meetingTitle",
    "name",
    "status",
    "delayStatus",
  ]);
  const [taskViewClicked, setTaskViewClicked] = useState(false);
  const [order, setOrder] = useState("asc");
  const [isChartClickInProgress, setIsChartClickInProgress] = useState(false);
  const [isPaginationInProgress, setIsPaginationInProgress] = useState(false);

  const [lastCardClickType, setLastCardClickType] = useState(null);
  //MARKER
  const [actionStatus, setAactionStatus] = useState(null);
  const [priority, setPriority] = useState(null);
  const [activityDetails, setActivityDetails] = useState(null);
  const [attendeesData, setAttendeesData] = useState([]);
  //MARKER

  const [isModalOpen, setIsModalOpen] = useState(false);
  const loginUserData = useSelector((state) => state.user);

  if (authData.isInValidUser && authData.isInvalidUserChecked) {
    localStorage.removeItem("accessToken");
    localStorage.removeItem("userData");
    localStorage.removeItem("rememberMe");
    dispatch(logOut());
    navigate("/login");
  }
  const [isRequestForReassignModalOpen, setIsRequestForReassignModalOpen] =
    useState(false);
  const [searchData, setSearchData] = useState({
    searchKey: "",
    page: 1,
    limit: 5,
    order: -1,
    filterData: {},
  });

  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const lastCardClickTypeRef = useRef(null);
  const [query, setQuery] = useState("");
  const [debouncedQuery, setDebouncedQuery] = useState(query);
  const prevDebouncedRef = useRef(debouncedQuery);

  const [screenSize, setScreenSize] = useState(window.innerWidth);
  useEffect(() => {
    const handleResize = () => {
      setScreenSize(window.innerWidth);
    };

    // Add event listener
    window.addEventListener("resize", handleResize);

    // Call on initial render if needed
    handleResize();

    // Cleanup listener on unmount
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Debounce effect
  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedQuery(query);
    }, 800);
    return () => {
      clearTimeout(handler);
    };
  }, [query]);
  useEffect(() => {
    if (isChartClicked) {
      setSearchData((prev) => ({
        ...prev,
        page: 1,
      }));
    } else {
      dispatch(setChartClickType(false));
    }
  }, [isChartClicked]);

  const buildAndDispatchPayload = useCallback(
    (queryKey) => {
      const basePayload = {
        page: searchData.page,
        limit: searchData.limit,
        order: searchData.order,
        organizationId:
          employeeData?.userData?.organizationId || userData?.organizationId,
        toDate: searchData.filterData?.toDate,
        fromDate: searchData.filterData?.fromDate,
        createdById: searchData.filterData?.ownerId || undefined,
        meetingId: searchData.filterData?.meetingId || undefined,
        accessToken,
        priority: priority,
        actionStatus:
          searchData.filterData?.actionStatus || actionStatus || undefined,
        assignedUserId: searchData.filterData?.assignedUserId || undefined,
        delayStatus: searchData.filterData?.delayStatus || undefined,
        isFilterClick: actionData.isFilterclick|| false,
      };
      console.log("actionData.lastCardClickType",actionData.lastCardClickType)
      console.log("basePayload", basePayload);
      if (!isMyTasks) {
        basePayload.assignedUserId =
          searchData.filterData?.assignedUserId || undefined;
      } else {
        Object.assign(basePayload, filterPayload);
      }

      if (queryKey && queryKey === prevDebouncedRef.current) {
        basePayload.searchKey = queryKey;
      }

      if (queryKey && queryKey !== prevDebouncedRef.current) {
        basePayload.searchKey = queryKey;
        setSearchData((prev) => ({ ...prev, page: 1 }));
        basePayload.page = 1;
      }
      if (!authData.isInValidUser) {
        switch (actionData.lastCardClickType) {
          case "PENDING":
            basePayload.actionStatus = "PENDING";
            dispatch(handlePriorityCardClick(basePayload, accessToken));
            break;
          case "PRIORITY":
            basePayload.priority = priority;
            dispatch(totalPriorityCardClick(basePayload, accessToken));
            break;
          case "TOTAL_PENDING":
            basePayload.actionStatus = "PENDING";
            dispatch(handlePendingCardClick(basePayload, accessToken));
            break;
          case "MEETING":
            basePayload.meetingId = actionData.clickedMeetingId;
            dispatch(rechartsAllData(basePayload, accessToken));
            break;
          case "ATTENDEE":
            basePayload.assignedUserId = actionData.assignedUserId;
            dispatch(rechartsAttendeeData(basePayload, accessToken));
            break;
          case "MY_TASK":
            dispatch(fetchActionListNew(basePayload, accessToken));
            break;
          case "ALL":
            dispatch(fetchActionList(basePayload, accessToken));
            break;
          case "FILTER":
            // alert("FILTER");
            console.log(basePayload.isFilterClick)
            basePayload.isFilterClick = actionData.isFilterClick;
            dispatch(fetchActionList(basePayload, accessToken));
            break;
          // default:
          //   dispatch(fetchActionList(basePayload));
          default:
            //  only call fetchActionList when filter flag is true
            if (actionData.isFilterClick) {
              // alert("yrees");
              dispatch(fetchActionList(basePayload, accessToken));
            } else {
              //  alert("no");
              dispatch(fetchActionList(basePayload));
            }
        }
      }
    },
    [
      dispatch,
      isMyTasks,
      searchData,
      employeeData?.userData?.organizationId,
      accessToken,
      authData.isInValidUser,
      filterPayload,
      lastCardClickType,
      actionStatus,
      priority,
    ]
  );

  useEffect(() => {
    if (!authData.isInValidUser) {
      //  alert(1)
      dispatch(viewMeetingStatistics(userData.organizationId, accessToken));
      buildAndDispatchPayload(query);
    }
  }, [authData.isInValidUser]);

  const filterData = (data) => {
    setSearchData({
      ...searchData,
      filterData: data,
      page: 1,
    });
  };

  useEffect(() => {
    document.title = "Action List: MinutesVault";

    if (!accessToken || !userData) {
      navigate("/login");
      return;
    }

    const payload = {
      page: searchData.page,
      order: searchData.order,
      limit: searchData.limit,
      organizationId: userData.organizationId,
      actionStatus:
        searchData.filterData?.actionStatus || actionStatus || undefined,
      delayStatus: searchData.filterData?.delayStatus || undefined,
      toDate: searchData.filterData?.toDate,
      fromDate: searchData.filterData?.fromDate,
      createdById: searchData.filterData?.ownerId || undefined,
      meetingId: searchData.filterData?.meetingId || undefined,
      assignedUserId: searchData.filterData?.assignedUserId || undefined,
      accessToken,
    };

    buildAndDispatchPayload("");

    if (actionData.isSuccess) {
      setIsRequestForReassignModalOpen(false);
      setIsReassignModalOpen(false);
      setActionDatas(null);
      setIsCloseModalOpen(false);
    }
  }, [
    searchData.order,
    searchData.page,
    searchData.limit,
    searchData.filterData,
    // actionData.isSuccess,
    actionData.isFetchedActionList,
    authData.isInValidUser,
  ]);
  useEffect(() => {
    return () => {
      dispatch(setCardClickType(null));
      dispatch(hidemytaskButton(false));
    };
  }, []);

  useEffect(() => {
    if (debouncedQuery || (prevDebouncedRef.current && debouncedQuery === "")) {
      //  alert(3)
      buildAndDispatchPayload(debouncedQuery);
    }

    if (actionData.isSuccess) {
      setIsRequestForReassignModalOpen(false);
      setIsReassignModalOpen(false);
      setActionDatas(null);
      setIsCloseModalOpen(false);
    }

    prevDebouncedRef.current = debouncedQuery;
  }, [debouncedQuery]);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    window.addEventListener("resize", handleResize);

    // Clean up the event listener on unmount
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const handleChange = (e) => {
    setErrors({});
    const { name, value } = e.target;
    setQuery(value);
  };

  const totalOption =
    actionData?.totalCount && actionData?.totalCount % 5 === 0
      ? Math.round(actionData.totalCount / 5)
      : actionData?.totalCount && actionData?.totalCount % 5 !== 0
        ? Math.round(actionData.totalCount / 5 + 0.5)
        : 0;

  const checkTotalPage =
    actionData.totalCount % searchData.limit === 0
      ? Math.round(actionData.totalCount / searchData.limit)
      : Math.round(actionData.totalCount / searchData.limit + 0.5);

  const totalPage = actionData.totalCount ? checkTotalPage : 0;

  const totalPageArray = Array(totalPage).fill();

  const fromDataCount =
    actionData?.actionList?.length === 0
      ? 0
      : (searchData.page - 1) * searchData.limit + 1;
  const toDataCount =
    (searchData.page - 1) * searchData.limit + actionData?.actionList?.length;
  const totalCount = actionData.totalCount;
  const [minuteDetails, setMinuteDetails] = useState(null);

  const [actionId, setActionId] = useState(null);
  const [actionDatas, setActionDatas] = useState(null);

  const handleRequestForReassign = (reason, minute) => {
    setMinuteDetails(minute);
    const cleanedAssignedUsers =
      actionData?.actionList[0]?.assignedUserDetails?.map(
        ({ profilePicture, isEmployee, ...rest }) => rest
      );
    dispatch(
      processRequestForReassign(
        actionId,
        {
          requestDetails: reason,
          assignedUsers: cleanedAssignedUsers,
        },
        accessToken
      )
    );
    setActionId(null);
    setIsRequestForReassignModalOpen(false);
  };
  const handleCancelAction = (status, minute) => {
    setMinuteDetails(minute);
    setIsCloseModalOpen(status);
  };
  const submitCancelAction = async () => {
    const payload = {
      assignedUserDetails: minuteDetails?.assignedUserDetails,
    };
    setLoading(true);
    const result = await dispatch(
      cancelActionInList(
        minuteDetails?.meetingId,
        minuteDetails?._id,
        accessToken,
        payload
      )
    );
    setLoading(false);
    if (result?.status) {
      buildAndDispatchPayload("");
      setIsCloseModalOpen(false);
      dispatch(viewMeetingStatistics(userData.organizationId, accessToken));

      const payload = {
        page,
        order: -1,
        limit: 5,
        organizationId: employeeData?.userData?.organizationId,
      };
      if (!authData.isInValidUser) {
        dispatch(getMeetingActionPriotityDetails(payload, accessToken));
      }
    }
  };
  const handleReassign = (data) => {
    dispatch(
      processReassign(
        actionId,

        {
          organizationId: userData?.organizationId,
          assignedUsers: data.assignedUsers,
          reAssignReason: data.reason,
          dueDate: data.date ? data.date : undefined,
          priority: data.priority,
          lastActionActivityId: data?.lastActionActivityId,
        },
        accessToken
      )
    );
    setActionId(null);
  };
  const handleRequestForReassignModal = (actionId) => {
    setActionId(actionId);
    setIsRequestForReassignModalOpen(true);
  };

  const handleReassignModal = (action) => {
    setActionId(action._id);
    setActionDatas(action);
    setIsReassignModalOpen(true);
    setActivityDetails(action.lastActionActivityId);
  };

  const handlePageChange = (event, value) => {
    setSearchData({
      ...searchData,
      page: value,
    });
  };

  const setUser = () => {
    setAactionStatus(null);
    setQuery("");
    setDebouncedQuery("");
    setShowUserData(true);
    setIsMyTasks(true);
    setTaskViewClicked(true);
    dispatch(hidemytaskButton(false));
    dispatch(setChartClickType(false));
    dispatch(setCardClickType(null));
    setPriority(null);

    const filters = {
      organizationId: userData?.organizationId,
      assignedUserId: userData?._id,
    };

    const updatedSearchData = {
      searchKey: "",
      limit: 5,
      order: -1,
      filterData: {},
      page: 1,
    };

    setFilterPayload(filters);
    //setSearchData(updatedSearchData);
    setSearchData({
      ...searchData,
      searchKey: "",
      limit: 5,
      order: -1,
      filterData: {},
      page: 1,
    });

    const payload = {
      ...filters,
      page: 1,
      limit: 5,
      order: -1,
    };

    dispatch(fetchActionListNew(payload, accessToken));
  };

  const setAll = () => {
    setAactionStatus(null);
    setQuery("");
    setDebouncedQuery("");
    setShowUserData(false);
    setIsMyTasks(false);
    setTaskViewClicked(true);
    setPriority(null);
    dispatch(hidemytaskButton(false));
    dispatch(setCardClickType(null));
    dispatch(setChartClickType(false));
    const filters = {
      organizationId: userData?.organizationId,
    };

    setFilterPayload(filters);
    setSearchData({
      ...searchData,
      searchKey: "",
      limit: 5,
      order: -1,
      filterData: {},
      page: 1,
    });
    const payload = {
      ...filters,
      page: 1,
      limit: 5,
      order: -1,
    };

    dispatch(fetchActionListNew(payload, accessToken));
  };

  const popoverHoverFocus = (title) => {
    return (
      <Popover id="popover-basic" className="custom-popover">
        <Popover.Body className="popover-body">{title}</Popover.Body>
      </Popover>
    );
  };

  const meetingDetailsPopover = (title) => {
    return (
      <Popover id="popover-basic" className="custom-popover">
        <Popover.Body className="popover-body">{title}</Popover.Body>
      </Popover>
    );
  };
  const tooltip = (attendee) => {
    return (
      <Tooltip id="tooltip">
        {attendee.name} / {attendee?.email}
      </Tooltip>
    );
  };
  const handleSort = (property) => {
    const isAsc = orderBy === property && order === "asc";
    const newOrder = isAsc ? "desc" : "asc";
    setOrder(newOrder);
    setOrderBy(property);
  };
  const sortedMeetings = [...(actionData?.actionList || [])].sort((a, b) => {
    let aVal = a[orderBy];
    let bVal = b[orderBy];

    switch (orderBy) {
      case "name":
        aVal = a?.assignedUserDetails?.name?.toLowerCase() || "";
        bVal = b?.assignedUserDetails?.name?.toLowerCase() || "";
        break;
      case "title":
        aVal = (a?.title || "").toLowerCase();
        bVal = (b?.title || "").toLowerCase();
        break;
      case "mainDueDate":
        aVal = new Date(aVal);
        bVal = new Date(bVal);
        break;
      case "meetingTitle":
        const aTitle = a?.meetingDetails?.title ? a?.meetingDetails?.title : "";
        const bTitle = b?.meetingDetails?.title ? b?.meetingDetails?.title : "";
        aVal = aTitle.toLowerCase();
        bVal = bTitle.toLowerCase();
        break;

      case "priority":
        const priorityRank = { high: 1, normal: 2, low: 3 };
        aVal = priorityRank[(a?.priority || "").toLowerCase()] || 999;
        bVal = priorityRank[(b?.priority || "").toLowerCase()] || 999;
        break;

      case "status":
        const statusRank = {
          PENDING: 1,
          REQUESTFORREASSIGN: 2,
          REASSIGNED: 3,
          COMPLETED: 4,
          REOPENED: 5,
          APPROVED: 6,
          CANCELLED: 7,
        };

        aVal = statusRank[a?.actionStatus || ""] || 999;
        bVal = statusRank[b?.actionStatus || ""] || 999;
        break;

      case "delayStatus":
        const delayRank = {
          true: 1, // Delayed
          false: 2, // Not Delayed
          cancelled: 3, // Cancelled last
        };

        const getDelayValue = (item) => {
          if (item?.actionStatus === "CANCELLED") return delayRank.cancelled;
          if (item?.isDelayed)
            return delayRank.true - (item?.delayCountInDays || 0) / 10000;
          return delayRank[String(item?.isDelayed)] || 999;
        };

        aVal = getDelayValue(a);
        bVal = getDelayValue(b);
        break;
    }

    const result =
      aVal < bVal
        ? order === "asc"
          ? -1
          : 1
        : aVal > bVal
          ? order === "asc"
            ? 1
            : -1
          : 0;

    return result;
  });

  const location = useLocation();

  const camefromPreviousPage = location.state?.camefromPreviousPage || false;

  const setModalStatus = (value, action) => {
    setIsModalOpen(value);
    setAttendeesData(action.assignedUserDetails);
  };

  const handlePendingClick = () => {
    setFilterPayload({});
    dispatch(setAttendeeAndMeetingChartFalse());
    setSearchData({ ...searchData, page: 1, limit: 5 });
    setPriority(null);
    dispatch(hidemytaskButton(true));
    const payload = {
      page: 1,
      order: searchData.order,
      limit: 5,
      organizationId: userData?.organizationId,
      actionStatus: "PENDING",
    };

    if (!payload.organizationId) {
      console.error("organizationId is missing in payload!");
      return;
    }

    dispatch(handlePendingCardClick(payload, accessToken));
    setAactionStatus("PENDING");
    const tableSection = document.getElementById("table-section");
    if (tableSection) {
      tableSection.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };
  const handleTotalDue = () => {
    setAactionStatus(null);
    dispatch(hidemytaskButton(false));
    dispatch(setCardClickType(null));
    dispatch(setChartClickType(false));
    setSearchData({
      ...searchData,
      filterData: {},
      page: 1,
      limit: 5,
    });
    const payload = {
      page: searchData.page,
      order: searchData.order,
      limit: searchData.limit,
      organizationId: userData.organizationId,
      delayStatus: searchData.filterData?.delayStatus || undefined,
      toDate: searchData.filterData?.toDate,
      fromDate: searchData.filterData?.fromDate,
      createdById: searchData.filterData?.ownerId || undefined,
      meetingId: searchData.filterData?.meetingId || undefined,
      assignedUserId: searchData.filterData?.assignedUserId || undefined,
      accessToken,
    };

    if (searchData.searchKey !== "") {
      payload["searchKey"] = searchData.searchKey;
      setSearchData({ ...searchData, page: 1, limit: 5 });
      payload.page = 1;
    }
    dispatch(hidemytaskButton(true));

    if (!authData.isInValidUser) {
      if (
        !actionData?.isAttendeeChartOpened &&
        !actionData?.isMeetingChartOpened
      ) {
        if (actionStatus !== null && priority !== null) {
          const payload = {
            page: searchData.page,
            order: searchData.order,
            limit: searchData.limit,
            organizationId: userData?.organizationId,
            actionStatus: actionStatus,
            priority: priority,
          };
        }
      }
    }

    // Dispatch fetchActionList with payload and accessToken
    dispatch(fetchActionList(payload, accessToken)); // Make sure
    // Smooth scroll to the table section
    const tableSection = document.getElementById("table-section");
    if (tableSection) {
      tableSection.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  const handlePrioritywiseClick = (priority) => {
    dispatch(setAttendeeAndMeetingChartFalse());
    setSearchData({ ...searchData, page: 1, limit: 5 });

    dispatch(hidemytaskButton(true));
    const validPriorities = ["HIGH", "LOW", "NORMAL"];
    if (!validPriorities.includes(priority)) {
      console.error(
        `Invalid priority value: ${priority}. Allowed values: HIGH, LOW, NORMAL.`
      );
      return;
    }

    const payload = {
      page: 1,
      order: searchData.order,
      limit: searchData.limit,
      organizationId: userData?.organizationId,
      priority: priority,
    };

    if (!payload.organizationId) {
      console.error("organizationId is missing in payload!");
      return;
    }

    dispatch(totalPriorityCardClick(payload, accessToken));
    setPriority(priority);
    lastCardClickTypeRef.current = "PRIORITY";

    const tableSection = document.getElementById("table-section");
    if (tableSection) {
      tableSection.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  const handlePriorityClick = (priority, actionStatus) => {
    dispatch(setAttendeeAndMeetingChartFalse());
    setSearchData({ ...searchData, page: 1, limit: 5 });
    dispatch(hidemytaskButton(true));
    const validPriorities = ["HIGH", "LOW", "NORMAL"];
    if (!validPriorities.includes(priority)) {
      console.error(
        `Invalid priority value: ${priority}. Allowed values: HIGH, LOW, NORMAL.`
      );
      return;
    }
    const payload = {
      //page: searchData.page,
      page: 1,
      order: searchData.order,
      limit: searchData.limit,
      organizationId: userData?.organizationId,
      actionStatus: actionStatus,
      priority: priority,
    };
    if (!payload.organizationId) {
      console.error("organizationId is missing in payload!");
      return;
    }

    dispatch(handlePriorityCardClick(payload, accessToken));
    setPriority(priority);

    //setLastCardClickType("PRIORITY");
    const tableSection = document.getElementById("table-section");
    if (tableSection) {
      tableSection.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };
  return (
    <>
      <div className="main-content">
        <div className="meeting-page ">
          <div className="meeting-header-text line-height-h4">
            <div>
              <h4>Actions</h4>
            </div>
          </div>

          <div className="color-box-resp action-list-box">
            <div className="row mt-3">
              <div className="col-xl-3 col-md-6 col-sm-6 col-6">
                <div className="panel-db panel to-cyan2-400 d-flex justify-content-between">
                  <div>
                    <div className="flex justify-between title-min-height">
                      <div className="ltr:mr-1 rtl:ml-1 text-md font-semibold">
                        Total Due
                      </div>
                    </div>
                    <div className="flex items-center mt-3">
                      <div
                        className="text-3xl font-bold cursor-pointer"
                        onClick={handlePendingClick}
                      >
                        {meetingData?.meetingStatisticsData &&
                        !meetingData.loading
                          ? meetingData?.meetingStatisticsData?.totalDueAction
                          : 0}
                      </div>
                    </div>
                  </div>
                  <div
                    className="flex items-center font-semibold mt-3 title-min-height cursor-pointer"
                    onClick={handleTotalDue}
                  >
                    All (
                    {meetingData?.meetingStatisticsData && !meetingData.loading
                      ? meetingData?.meetingStatisticsData?.totalAction
                      : 0}
                    )
                  </div>
                </div>
              </div>
              <div className="col-xl-3 col-md-6 col-sm-6 col-6">
                <div className="panel-db panel to-fuchsia-400 d-flex justify-content-between">
                  <div>
                    <div className="flex justify-between title-min-height">
                      <div className="ltr:mr-1 rtl:ml-1 text-md font-semibold">
                        Total High Priority Due
                      </div>
                    </div>
                    <div className="flex items-center mt-3">
                      <div
                        className="text-3xl font-bold cursor-pointer"
                        onClick={() => handlePriorityClick("HIGH", "PENDING")}
                      >
                        {" "}
                        {meetingData?.meetingStatisticsData &&
                        !meetingData.loading
                          ? meetingData?.meetingStatisticsData
                              ?.totalHighPriorityDueAction
                          : 0}
                      </div>
                    </div>
                  </div>
                  <div
                    className="flex align-items-center font-semibold mt-3 title-min-height cursor-pointer"
                    onClick={() => handlePrioritywiseClick("HIGH")}
                  >
                    All High Priority (
                    {meetingData?.meetingStatisticsData && !meetingData.loading
                      ? meetingData?.meetingStatisticsData
                          ?.totalHighPriorityAction
                      : 0}
                    )
                  </div>
                </div>
              </div>
              <div className="col-xl-3 col-md-6 col-sm-6 col-6">
                <div className="panel-db panel to-blue-400 d-flex justify-content-between">
                  <div>
                    <div className="flex justify-between title-min-height">
                      <div className="ltr:mr-1 rtl:ml-1 text-md font-semibold">
                        Total Normal Priority Due
                      </div>
                    </div>
                    <div className="flex items-center mt-3">
                      <div
                        className="text-3xl font-bold cursor-pointer"
                        onClick={() => handlePriorityClick("NORMAL", "PENDING")}
                      >
                        {meetingData?.meetingStatisticsData &&
                        !meetingData.loading
                          ? meetingData?.meetingStatisticsData
                              ?.totalMediumPriorityDueAction
                          : 0}{" "}
                      </div>
                    </div>
                  </div>
                  <div
                    className="flex align-items-center font-semibold mt-3 title-min-height cursor-pointer"
                    onClick={() => handlePrioritywiseClick("NORMAL")}
                  >
                    All Normal Priority (
                    {meetingData?.meetingStatisticsData && !meetingData.loading
                      ? meetingData?.meetingStatisticsData
                          ?.totalNormalPrioprityAction
                      : 0}
                    )
                  </div>
                </div>
              </div>
              <div className="col-xl-3 col-md-6 col-sm-6 col-6">
                <div className="panel-db panel to-green-400 d-flex justify-content-between">
                  <div>
                    <div className="flex justify-between title-min-height">
                      <div className="ltr:mr-1 rtl:ml-1 text-md font-semibold">
                        Total Low Priority Due
                      </div>
                    </div>
                    <div
                      className="flex items-center mt-3  cursor-pointer"
                      onClick={() => handlePriorityClick("LOW", "PENDING")}
                    >
                      <div className="text-3xl font-bold">
                        {meetingData?.meetingStatisticsData &&
                        !meetingData.loading
                          ? meetingData?.meetingStatisticsData
                              ?.totalLowPriorityDueAction
                          : 0}{" "}
                      </div>
                    </div>
                  </div>
                  <div
                    className="flex align-items-center font-semibold mt-3 title-min-height cursor-pointer"
                    onClick={() => handlePrioritywiseClick("LOW")}
                  >
                    All Low Priority (
                    {meetingData?.meetingStatisticsData && !meetingData.loading
                      ? meetingData?.meetingStatisticsData
                          ?.totalLowPriorityAction
                      : 0}
                    )
                  </div>
                </div>
              </div>
            </div>
          </div>

          <ActionFilterComponent
            setfilter={setfilter}
            filterData={filterData}
            initData={searchData.filterData}
            filter={filter}
            taskViewClicked={isMyTasks}
          />

          <div>
            <div className="left-tbl-text">
              <ActionPieChart organizationId={userData?.organizationId} />
            </div>
          </div>
          <div
            id="table-section"
            className="mt-2 table-box responsive-table resp-mt-30"
          >
            <div className="d-flex align-items-center justify-content-between resp-flex-column mb-2">
              <div className="left-tbl-text">
                {totalCount > 0 ? (
                  <p>
                    Showing {fromDataCount} to {toDataCount} of {totalCount}{" "}
                    actions
                  </p>
                ) : null}
              </div>
              <div className="meeting-f-search">
                <div>
                  <div className="search-box">
                    <input
                      type="search"
                      placeholder="Search By Action Title..."
                      onChange={handleChange}
                      name="query"
                      value={query}
                      autoComplete="off"
                    />
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      fill="#4F2CC8"
                      className="bi bi-search"
                      viewBox="0 0 16 16"
                    >
                      <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001q.044.06.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1 1 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0" />
                    </svg>
                  </div>
                  {errors?.searchKey && (
                    <span className="error-message">{errors?.searchKey}</span>
                  )}
                </div>
                <button
                  type="button"
                  className="btn add-btn Mom-btn d-flex align-items-center justify-content-center filter-height"
                  id="open-form-btn-meetinglist"
                  onClick={(e) => setfilter(true)}
                >
                  <p>Filter</p>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    fill="currentColor"
                    className="bi bi-funnel filter-svg"
                    viewBox="0 0 16 16"
                  >
                    <path d="M1.5 1.5A.5.5 0 0 1 2 1h12a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-.128.334L10 8.692V13.5a.5.5 0 0 1-.342.474l-3 1A.5.5 0 0 1 6 14.5V8.692L1.628 3.834A.5.5 0 0 1 1.5 3.5zm1 .5v1.308l4.372 4.858A.5.5 0 0 1 7 8.5v5.306l2-.666V8.5a.5.5 0 0 1 .128-.334L13.5 3.308V2z" />
                  </svg>
                </button>
              </div>
            </div>

            {(actionData.actionList.length > 0 || taskViewClicked) && (
              <div className="graph-btn d-flex align-items-center">
                <button
                  onClick={setAll}
                  className={`badge bg-opacity-10 me-2 all-btn padding-btnall ${
                    hideMyTaskButton
                      ? "newbtn-color"
                      : showUserData
                        ? "disable-btn"
                        : "newbtn-color"
                  }`}
                >
                  All Task
                </button>

                {!hideMyTaskButton && (
                  <button
                    onClick={setUser}
                    className={`badge bg-opacity-10 me-2 all-btn padding-btn ${
                      showUserData ? "newbtn-color" : "disable-btn"
                    }`}
                  >
                    My Task
                  </button>
                )}
              </div>
            )}

            {actionData.loading == false &&
            actionData.actionList?.length !== 0 &&
            actionData.isSuccess ? (
              <div className="">
                <table className="mt-2 table table-bordered table-striped action-list-table">
                  <thead>
                    <tr>
                      <th scope="col" className="text-align-center">
                        Sl.No
                      </th>

                      <th scope="col" className="text-align-center">
                        {" "}
                        Due Date
                        <TableSortLabel
                          active={orderBy.includes("mainDueDate")}
                          direction={orderBy === "mainDueDate" ? order : "asc"}
                          hideSortIcon={false}
                          onClick={() => handleSort("mainDueDate")}
                        />
                      </th>

                      <th scope="col">
                        {" "}
                        Action Title
                        <TableSortLabel
                          active={orderBy.includes("title")}
                          direction={orderBy === "title" ? order : "asc"}
                          hideSortIcon={false}
                          onClick={() => handleSort("title")}
                        />
                      </th>

                      <th scope="col" className="text-align-center">
                        {" "}
                        Priority
                        <TableSortLabel
                          active={orderBy.includes("priority")}
                          direction={orderBy === "priority" ? order : "asc"}
                          hideSortIcon={false}
                          onClick={() => handleSort("priority")}
                        ></TableSortLabel>
                      </th>

                      <th scope="col" className="text-align-center">
                        Assigned to
                        <TableSortLabel
                          active={orderBy.includes("name")}
                          direction={orderBy === "name" ? order : "asc"}
                          hideSortIcon={false}
                          onClick={() => handleSort("name")}
                        />
                      </th>

                      <th scope="col" className="text-align-center">
                        Status
                        <TableSortLabel
                          active={orderBy.includes("status")}
                          direction={orderBy === "status" ? order : "asc"}
                          hideSortIcon={false}
                          onClick={() => handleSort("status")}
                        />
                      </th>

                      <th scope="col" className="text-align-center">
                        Delay Status
                        <TableSortLabel
                          active={orderBy.includes("delayStatus")}
                          direction={orderBy === "delayStatus" ? order : "asc"}
                          hideSortIcon={false}
                          onClick={() => handleSort("delayStatus")}
                        />
                      </th>

                      {screenSize <= 768 ? null : (
                        <th className="action-col" scope="col">
                          Action
                        </th>
                      )}
                    </tr>
                  </thead>
                  <tbody>
                    {sortedMeetings.map((action, index) => {
                      return (
                        <tr>
                          <td
                            data-label="Sl.No"
                            className="meeting-td-width-9 text-align-center blue-bold-text"
                          >
                            {(searchData.page - 1) * (searchData.limit || 10) +
                              index +
                              1}

                            {screenSize <= 768 ? (
                              <div className="d-inline-block menu-dropdown custom-dropdown inner1-drp">
                                <ActionDropDown
                                  action={action}
                                  handleRequestForReassignModal={() => {
                                    handleRequestForReassignModal(action?._id);
                                  }}
                                  handleReassignModal={() => {
                                    handleReassignModal(
                                      action,
                                      activityDetails
                                    );
                                  }}
                                  handleCancelActionModal={() => {
                                    handleCancelAction(true, action);
                                  }}
                                />
                              </div>
                            ) : null}
                          </td>
                          <td
                            data-label="Due Date"
                            className="meeting-td-width-6 text-align-center"
                          >
                            {action?.mainDueDate}
                          </td>

                          <td
                            data-label="Action Title"
                            className="meeting-td-width word-break"
                          >
                            <Link
                              to={`/view-action-detail/${action?._id}`}
                              state={{ camefromPreviousPage: true }}
                              style={{
                                textDecoration: "none",
                                color: "black",
                              }}
                            >
                              {" "}
                              {screenSize <= 768 ? (
                                <div>
                                  {" "}
                                  {action?.title?.length > 45 ? (
                                    <OverlayTrigger
                                      trigger={["hover", "focus"]}
                                      placement="top"
                                      overlay={popoverHoverFocus(action?.title)}
                                    >
                                      <span>
                                        {`${sliceTextFromHTML(
                                          action?.title,
                                          0,
                                          45
                                        )}....`}
                                      </span>
                                    </OverlayTrigger>
                                  ) : (
                                    action?.title
                                  )}
                                </div>
                              ) : (
                                <div>
                                  {" "}
                                  {action?.title?.length > 35 ? (
                                    <OverlayTrigger
                                      trigger={["hover", "focus"]}
                                      placement="top"
                                      overlay={popoverHoverFocus(action?.title)}
                                    >
                                      <span>
                                        {`${sliceTextFromHTML(
                                          action?.title,
                                          0,
                                          35
                                        )}....`}
                                      </span>
                                    </OverlayTrigger>
                                  ) : (
                                    action?.title
                                  )}
                                </div>
                              )}{" "}
                            </Link>
                            <p className="detail-date-time">
                              Meeting ID - {action?.meetingDetails?.meetingId}
                            </p>
                          </td>

                          <td
                            data-label="Priority"
                            className="meeting-td-width-7 text-align-center"
                          >
                            {" "}
                            {action?.priority?.charAt(0).toUpperCase() +
                              action?.priority?.slice(1).toLowerCase()}
                          </td>
                          <td
                            data-label="Assigned to"
                            className="meeting-td-width-6 attendees-center"
                            onClick={(e) => {
                              setModalStatus(true, action);
                            }}
                          >
                            {action?.assignedUserDetails &&
                            action.assignedUserDetails.length > 0 ? (
                              <>
                                <div className="attendees meeting-list-bg-transparent details-form">
                                  {action.assignedUserDetails
                                    .filter((item, index) => index < 3)
                                    .map((user) => (
                                      <OverlayTrigger
                                        key={user._id}
                                        placement="top"
                                        overlay={tooltip(user)}
                                        trigger={["hover", "focus"]}
                                      >
                                        <div
                                          className={`attendee-list attendee-list-circle${
                                            action?.meetingDetails?.createdById?.toString() ===
                                            user._id.toString()
                                              ? " attendees-border"
                                              : ""
                                          }`}
                                          style={{
                                            backgroundColor:
                                              user?.profilePicture
                                                ? undefined
                                                : getColorFromId(user?._id),
                                          }}
                                        >
                                          {user?.profilePicture ? (
                                            <img
                                              src={`${process.env.REACT_APP_API_URL}${user.profilePicture}`}
                                              alt=""
                                              className="attendee-profile-picture icon-image attendee-list-circle-img"
                                              onError={(e) => {
                                                e.target.onerror = null;
                                                e.target.style.display = "none";
                                                e.target.parentElement.style.backgroundColor =
                                                  getColorFromId(user._id);
                                                e.target.parentElement.innerText =
                                                  customName(user?.name);
                                              }}
                                            />
                                          ) : (
                                            <span className="attendee-name">
                                              {customName(user?.name)}
                                            </span>
                                          )}
                                        </div>
                                      </OverlayTrigger>
                                    ))}
                                </div>
                                {action.assignedUserDetails.length > 3 && (
                                  <p className="m-0 plus-more-text">
                                    +{action.assignedUserDetails.length - 3}{" "}
                                    More
                                  </p>
                                )}
                              </>
                            ) : (
                              "Not Available"
                            )}
                          </td>

                          <td
                            data-label="Status"
                            className="meeting-td-width-0  text-align-center"
                          >
                            {action?.actionStatus === "COMPLETED" ? (
                              <span className="badge completed-color bg-opacity-10 ">
                                Completed
                              </span>
                            ) : null}
                            {action?.actionStatus === "REOPENED" ? (
                              <span className="badge reopened-color bg-opacity-10 ">
                                Reopened
                              </span>
                            ) : null}
                            {action?.actionStatus === "APPROVED" ? (
                              <span className="badge approved-color bg-opacity-10 ">
                                Approved
                              </span>
                            ) : null}

                            {employeeData?.userData?.isAdmin === false &&
                            employeeData?.userData?._id?.toString() !==
                              action?.meetingDetails?.createdById?.toString() &&
                            action?.actionStatus === "REQUESTFORREASSIGN" ? (
                              action?.reassigneRequestDetails?.[
                                action?.reassigneRequestDetails?.length - 1
                              ]?.userId?.toString() ===
                              employeeData?.userData?._id?.toString() ? (
                                <span className="badge forwardrequested-color bg-opacity-10">
                                  Forward Requested
                                </span>
                              ) : (
                                <span className="badge pending-color bg-opacity-10">
                                  Pending
                                </span>
                              )
                            ) : null}

                            {employeeData?.userData?.isAdmin === false &&
                            employeeData?.userData?._id?.toString() !==
                              action?.meetingDetails?.createdById?.toString() &&
                            action?.actionStatus === "PENDING" ? (
                              <span className="badge pending-color bg-opacity-10 ">
                                Pending
                              </span>
                            ) : null}
                            {(employeeData?.userData?.isAdmin ||
                              employeeData?.userData?._id?.toString() ===
                                action?.meetingDetails?.createdById?.toString()) &&
                            action?.actionStatus === "PENDING" ? (
                              <span className="badge pending-color bg-opacity-10 ">
                                Pending
                              </span>
                            ) : null}
                            {(employeeData.userData.isAdmin ||
                              employeeData?.userData?._id?.toString() ===
                                action?.meetingDetails?.createdById?.toString()) &&
                            action?.actionStatus === "REQUESTFORREASSIGN" ? (
                              <span className="badge forwardrequested-color bg-opacity-10 ">
                                Forward Requested
                              </span>
                            ) : null}

                            {(employeeData.userData.isAdmin ||
                              employeeData?.userData?._id?.toString() ===
                                action?.meetingDetails?.createdById?.toString()) &&
                            action?.actionStatus === "REASSIGNED" ? (
                              <span className="badge reassigned-color bg-opacity-10 ">
                                Forwarded
                              </span>
                            ) : null}
                            {!employeeData.userData.isAdmin &&
                            employeeData?.userData?._id?.toString() !==
                              action?.meetingDetails?.createdById?.toString() &&
                            action?.actionStatus === "REASSIGNED" ? (
                              <span className="badge reassigned-color bg-opacity-10 ">
                                Forwarded
                              </span>
                            ) : null}

                            {action?.actionStatus === "CANCELLED" ? (
                              <span className="badge canceled-color bg-opacity-10 ">
                                Cancelled
                              </span>
                            ) : null}
                          </td>

                          {action?.actionStatus === "CANCELLED" ? (
                            <td
                              data-label="Action"
                              className="text-align-center meeting-td-width-7 text-align-center"
                            >
                              <span className="badge NA-color bg-opacity-10 ">
                                NA
                              </span>
                            </td>
                          ) : (
                            <td
                              data-label="Delay Status"
                              className="text-align-center meeting-td-width-7 text-align-center"
                            >
                              {action?.isDelayed === true ? (
                                <>
                                  <span className="badge delay-color bg-opacity-10 ">
                                    Delayed
                                  </span>
                                  <p className="detail-date-time">
                                    {action?.completionStatus}
                                  </p>
                                </>
                              ) : (
                                <>
                                  <span className="badge notDelay-color bg-opacity-10 ">
                                    Not Delayed
                                  </span>
                                  <p className="detail-date-time">
                                    {action?.completionStatus}
                                  </p>
                                </>
                              )}
                            </td>
                          )}
                          {screenSize <= 768 ? null : (
                            <td
                              data-label="Action"
                              className="text-align-center meeting-td-width-7"
                            >
                              <div className="d-inline-block menu-dropdown custom-dropdown">
                                <ActionDropDown
                                  action={action}
                                  handleRequestForReassignModal={() => {
                                    handleRequestForReassignModal(action?._id);
                                  }}
                                  handleReassignModal={() => {
                                    handleReassignModal(action);
                                  }}
                                  handleCancelActionModal={() => {
                                    handleCancelAction(true, action);
                                  }}
                                />
                              </div>
                            </td>
                          )}
                        </tr>
                      );
                    })}
                    <tr></tr>
                  </tbody>
                </table>
              </div>
            ) : // </div>
            !actionData.loading && actionData.actionList?.length === 0 ? (
              <div className="no-data-img">
                <Alert
                  status={"info"}
                  message={"No data available."}
                  timeoutSeconds={0}
                />

                <NoDataFound dataType={"action"} />

                <Button
                  className="mt-2"
                  variant="primary"
                  onClick={(e) => {
                    setSearchData({
                      ...searchData,
                      searchKey: "",
                      filterData: {},
                      page: 1,
                    });
                    setQuery("");
                    setDebouncedQuery("");

                    setAactionStatus(null);

                    setShowUserData(false);
                    setIsMyTasks(false);
                    setTaskViewClicked(false);
                    setPriority(null);
                    dispatch(hidemytaskButton(false));
                    dispatch(setCardClickType(null));
                    dispatch(setChartClickType(false));
                  }}
                >
                  Clear
                </Button>
              </div>
            ) : (
              <div
                className="meeting-page "
                style={{ textAlign: "center", paddingTop: 20 }}
              >
                <Loader />
              </div>
            )}

            {totalCount <= 1 ? null : (
              <div className="tbl-bottom">
                <div className="left-tbl-bottom">
                  {searchData.page !== 1 ? (
                    <button
                      className="left-arrow"
                      onClick={(e) =>
                        setSearchData({
                          ...searchData,
                          page: searchData.page - 1,
                        })
                      }
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="#fff"
                        className="bi bi-chevron-left"
                        viewBox="0 0 16 16"
                      >
                        <path
                          fill-rule="evenodd"
                          d="M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0"
                        />
                      </svg>
                    </button>
                  ) : null}

                  {/* Pagination Component from MUI without arrows */}
                  <Stack spacing={2}>
                    <Pagination
                      count={totalPage}
                      page={searchData.page}
                      siblingCount={0}
                      boundaryCount={2}
                      onChange={handlePageChange}
                      hidePrevButton
                      hideNextButton
                      sx={{
                        "& .Mui-selected": {
                          backgroundColor: "#388d27 !important",
                          color: "#fff !important",
                        },
                      }}
                    />
                  </Stack>
                  {totalPageArray?.length !== searchData.page ? (
                    <button
                      className="right-arrow"
                      onClick={(e) =>
                        setSearchData({
                          ...searchData,
                          page: searchData.page + 1,
                        })
                      }
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="#fff"
                        viewBox="0 0 16 16"
                      >
                        <path
                          fill-rule="evenodd"
                          d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708"
                        />
                      </svg>
                    </button>
                  ) : null}
                </div>

                <div className="right-tbl-bottom">
                  <p>Rows Per Page</p>
                  <select
                    className="no-opt-box"
                    name="limit"
                    onChange={(e) =>
                      setSearchData({
                        ...searchData,
                        page: 1,
                        limit: e.target.value,
                      })
                    }
                    value={searchData.limit}
                  >
                    {totalOption &&
                      Array(totalOption)
                        .fill()
                        .map((_, option) => {
                          return (
                            <option value={(option + 1) * 5}>
                              {(option + 1) * 5}
                            </option>
                          );
                        })}
                  </select>
                </div>
              </div>
            )}
          </div>
        </div>

        <ReassignModal
          setIsReassignModalOpen={setIsReassignModalOpen}
          isModalOpen={isReassignModalOpen}
          handleSubmit={handleReassign}
          actionData={actionDatas}
          meetingDate={actionDatas?.meetingDetails?.date}
          activity={activityDetails}
        />
        <AssignedAttendeesModal
          IsModalOpen={isModalOpen}
          attendees={attendeesData}
          setIsModalOpen={setIsModalOpen}
          loginUserData={loginUserData}
          isShow={true}
        />
      </div>
      {isRequestForReassignModalOpen && (
        <RequestForReassignModal
          setIsModalOpen={setIsRequestForReassignModalOpen}
          isModalOpen={isRequestForReassignModalOpen}
          actionId={actionId}
        />
      )}
      {isCloseModalOpen && (
        <CommonModal
          message={"Do you want to cancel the action ?"}
          title={"Cancel Action"}
          setIsModalOpen={setIsCloseModalOpen}
          isModalOpen={isCloseModalOpen}
          handleSubmit={submitCancelAction}
          buttonName={"Cancel"}
          isCalledFromOthers={true}
          updateLoading={loading}
        />
      )}
    </>
  );
});

export default ActionList;
